import React from "react";

export default function Function() {

    let scrollUp = () => { window.scrollTo({ top: 0, behavior: "smooth" }); }

    return (
        <div className="c-light-2">
            <h1 className="text-center pad-top-4">Utilities</h1>
            <h6 className="ts-i text-center pad-bottom-3 c-light-4 ft-secondary">
                Static and Extension Methods that simplify Code Scripting
            </h6>

            <h3 className="p-2">Overview</h3>
            <p className="pad-left-2">
                The Utilities module provide an extensive range of static and extension methods that significantly streamline script development.
                The comprehensive nature of the utilities allows for flexibility and power, ensuring that developers can tackle various common tasks with minimal effort.
                These methods allow developers to write less code, resulting in a cleaner and more maintainable codebase.                
            </p>

            <div className="p-2">
                <img className="block-center mar-bottom-3 img-border w-60" src="images/Library/Library/02 - [1950x1300] Utilities V2.png" alt=""/>            
            </div>

            <div className="container mar-bottom-3">
                <div className="row">
                    <div className="col-lg-7 col-md-12">
                        <a href="/#/magikus/utilities/create" className="t-dec-none" onClick={scrollUp}><h4 className="c-light-1 c-light-3-h p-3">Create</h4></a>
                        <p className="pad-left-3">
                            The Create utility is a static class that simplifies the initialization of Unity data types, allowing for more concise and readable code in diverse development scenarios.
                        </p>
                    </div>
                    <div className="p-2 col-lg-5 col-md-12">
                        <a href="/#/magikus/utilities/create" className="t-dec-none vertical-center" onClick={scrollUp}>
                            <img className="block-center img-border w-80" src="images/Library/Utilities/Create/Create - 09.jpg" alt=""/>            
                        </a>
                    </div>
                </div>
            </div>

            <div className="container mar-bottom-3">
                <div className="row">
                    <div className="col-lg-7 col-md-12">
                        <a href="/#/magikus/utilities/adapt" className="t-dec-none" onClick={scrollUp}><h4 className="c-light-1 c-light-3-h p-3">Adapt</h4></a>
                        <p className="pad-left-3">
                            The Adapt utilities class offers a versatile set of type transformation methods, streamlining common conversions in Unity game development to improve code readability and reduce boilerplate.
                        </p>
                    </div>
                    <div className="p-2 col-lg-5 col-md-12">
                        <a href="/#/magikus/utilities/adapt" className="t-dec-none vertical-center" onClick={scrollUp}>
                            <img className="block-center img-border w-80" src="images/Library/Utilities/Adapt/Adapt - 09.jpg" alt=""/>            
                        </a>
                    </div>
                </div>
            </div>

            <div className="container mar-bottom-3">
                <div className="row">
                    <div className="col-lg-7 col-md-12">
                        <a href="/#/magikus/utilities/mathop" className="t-dec-none" onClick={scrollUp}><h4 className="c-light-1 c-light-3-h p-3">Mathop</h4></a>
                        <p className="pad-left-3">
                            The Mathop utilities offer a versatile set of methods for simplifying mathematical operations across various data types, making complex calculations effortless and ideal for game development.
                        </p>
                    </div>
                    <div className="p-2 col-lg-5 col-md-12">
                        <a href="/#/magikus/utilities/mathop" className="t-dec-none vertical-center" onClick={scrollUp}>
                            <img className="block-center img-border w-80" src="images/Library/Utilities/Mathop/Mathop - 07.jpg" alt=""/>            
                        </a>
                    </div>
                </div>
            </div>

            <div className="container mar-bottom-3">
                <div className="row">
                    <div className="col-lg-7 col-md-12">
                        <a href="/#/magikus/utilities/textop" className="t-dec-none" onClick={scrollUp}><h4 className="c-light-1 c-light-3-h p-3">Textop</h4></a>
                        <p className="pad-left-3">
                            The Textop utilities offer powerful methods for efficient and flexible string manipulation, simplifying tasks like counting, modifying and pattern-checking.
                        </p>
                    </div>
                    <div className="p-2 col-lg-5 col-md-12">
                        <a href="/#/magikus/utilities/textop" className="t-dec-none vertical-center" onClick={scrollUp}>
                            <img className="block-center img-border w-80" src="images/Library/Utilities/Textop/Textop - 07.jpg" alt=""/>            
                        </a>
                    </div>
                </div>
            </div>

            <div className="container mar-bottom-3">
                <div className="row">
                    <div className="col-lg-7 col-md-12">
                        <a href="/#/magikus/utilities/randop" className="t-dec-none" onClick={scrollUp}><h4 className="c-light-1 c-light-3-h p-3">Randop</h4></a>
                        <p className="pad-left-3">
                            The Randop utilities offer developers a powerful toolkit for adding randomness to game interactions, enhancing realism and accelerating development with efficient, easy-to-implement methods for generating random points, selecting items and applying colors.
                        </p>
                    </div>
                    <div className="p-2 col-lg-5 col-md-12">
                        <a href="/#/magikus/utilities/randop" className="t-dec-none vertical-center" onClick={scrollUp}>
                            <img className="block-center img-border w-80" src="images/Library/Utilities/Randop/Randop - 09.jpg" alt=""/>            
                        </a>
                    </div>
                </div>
            </div>

            <div className="container mar-bottom-3">
                <div className="row">
                    <div className="col-lg-7 col-md-12">
                        <a href="/#/magikus/utilities/listop" className="t-dec-none" onClick={scrollUp}><h4 className="c-light-1 c-light-3-h p-3">Listop</h4></a>
                        <p className="pad-left-3">
                            The Listop utilities offer powerful and flexible methods for manipulating arrays and lists, simplifying complex operations and streamlining workflows in game development.
                        </p>
                    </div>
                    <div className="p-2 col-lg-5 col-md-12">
                        <a href="/#/magikus/utilities/listop" className="t-dec-none vertical-center" onClick={scrollUp}>
                            <img className="block-center img-border w-80" src="images/Library/Utilities/Listop/Listop - 09.jpg" alt=""/>            
                        </a>
                    </div>
                </div>
            </div>

            <div className="container mar-bottom-3">
                <div className="row">
                    <div className="col-lg-7 col-md-12">
                        <a href="/#/magikus/utilities/looping" className="t-dec-none" onClick={scrollUp}><h4 className="c-light-1 c-light-3-h p-3">Looping</h4></a>
                        <p className="pad-left-3">
                            The Looping utilities simplify collection iteration in Unity, enabling forward and backward looping with improved code readability and maintainability.
                        </p>
                    </div>
                    <div className="p-2 col-lg-5 col-md-12">
                        <a href="/#/magikus/utilities/looping" className="t-dec-none vertical-center" onClick={scrollUp}>
                            <img className="block-center img-border w-80" src="images/Library/Utilities/Looping/Looping - 09.jpg" alt=""/>            
                        </a>
                    </div>
                </div>
            </div>

            <div className="container mar-bottom-3">
                <div className="row">
                    <div className="col-lg-7 col-md-12">
                        <a href="/#/magikus/utilities/easing" className="t-dec-none" onClick={scrollUp}><h4 className="c-light-1 c-light-3-h p-3">Easing</h4></a>
                        <p className="pad-left-3">
                            The Easing utilities offer versatile methods for crafting smooth, customizable transitions, perfect for enhancing animations, UI elements and game effects.
                        </p>
                    </div>
                    <div className="p-2 col-lg-5 col-md-12">
                        <a href="/#/magikus/utilities/easing" className="t-dec-none vertical-center" onClick={scrollUp}>
                            <img className="block-center img-border w-80" src="images/Library/Utilities/Easing/Easing - 09.jpg" alt=""/>            
                        </a>
                    </div>
                </div>
            </div>

            <div className="container mar-bottom-3">
                <div className="row">
                    <div className="col-lg-7 col-md-12">
                        <a href="/#/magikus/utilities/controls" className="t-dec-none" onClick={scrollUp}><h4 className="c-light-1 c-light-3-h p-3">Controls</h4></a>
                        <p className="pad-left-3">
                            The Controls utilities streamline input handling and debugging in Unity, allowing developers to focus on core game logic by simplifying common input operations and enhancing console output.
                        </p>
                    </div>
                    <div className="p-2 col-lg-5 col-md-12">
                        <a href="/#/magikus/utilities/controls" className="t-dec-none vertical-center" onClick={scrollUp}>
                            <img className="block-center img-border w-80" src="images/Library/Utilities/Controls/Controls - 08.jpg" alt=""/>            
                        </a>
                    </div>
                </div>
            </div>

            <div className="container mar-bottom-3">
                <div className="row">
                    <div className="col-lg-7 col-md-12">
                        <a href="/#/magikus/utilities/datafile" className="t-dec-none" onClick={scrollUp}><h4 className="c-light-1 c-light-3-h p-3">Datafile</h4></a>
                        <p className="pad-left-3">
                            The Datafile utilities offer flexible methods for managing save files in Unity, making it easy to handle persistent data across multiple formats in game development.
                        </p>
                    </div>
                    <div className="p-2 col-lg-5 col-md-12">
                        <a href="/#/magikus/utilities/datafile" className="t-dec-none vertical-center" onClick={scrollUp}>
                            <img className="block-center img-border w-80" src="images/Library/Utilities/Datafile/Datafile - 09.jpg" alt=""/>            
                        </a>
                    </div>
                </div>
            </div>
{/*
*/}
       </div>
    );
}